<ng-container *ngIf="status$ | async as status">
  <div
    *ngIf="status === 'offline' || status === 'unreachable'"
    class="connection-warning"
    [attr.title]="messageKey(status) | translate"
    role="status"
    aria-live="polite"
  >
    <svg class="connection-warning__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M2.5 8.5a15 15 0 0 1 19 0" />
      <path d="M5.5 11.5a10 10 0 0 1 13 0" />
      <path d="M8.5 14.5a5 5 0 0 1 7 0" />
      <circle cx="12" cy="18" r="1" fill="currentColor" stroke="none" />
      <path d="M3 3 21 21" />
    </svg>
    <span class="visually-hidden">{{ messageKey(status) | translate }}</span>
  </div>
</ng-container>
